module.exports = {"id":"235663","name":"Guus Til","rating":"74","photo":"./data/images/photos/1/235663.png","club":{"name":"AZ","logo":"./data/images/clubs/AZ.png"},"positions":["MOC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GuusTil0.json
// module id = 1677
// module chunks = 0